/*  Init Toggle Button Component

    Usage:
    <w3-product-sticky-buybox></w3-product-sticky-buybox>

    Accepts:
*/

class ProductStickyBuybox extends HTMLElement {
    constructor() {
        super();

        this.bindEvents = this.bindEvents.bind(this);
        this.toggleVisibility = this.toggleVisibility.bind(this);
        this.updateVariantText = this.updateVariantText.bind(this);
        this.clickVariantProductForm = this.clickVariantProductForm.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.syncSwatchesAndComboBox = this.syncSwatchesAndComboBox.bind(this);
        this.observeSwatchChanges = this.observeSwatchChanges.bind(this);
        this.updateSelectedValue = this.updateSelectedValue.bind(this);
        this.updateSelectedValueRecharge = this.updateSelectedValueRecharge.bind(this);
        this.handleComboBoxClick = this.handleComboBoxClick.bind(this);
        this.handleSubscriptionSelectClick = this.handleSubscriptionSelectClick.bind(this)
    }

    connectedCallback() {
        this.productStickyBuybox = this;

        this.buyboxAddToCart = document.querySelector('.product-form')
        this.stockAlertButton = this.querySelector('.js-stock-alert-button')

        this.buttonSticky = this.querySelector('.product-sticky-buybox__button-text')
        this.mainProductOptions = document.querySelectorAll('.product-variant-option-form');

        this.variantSelectMobile = document.querySelector('.product-sticky-buybox__select');

        this.bindEvents();

        document.addEventListener('onvariantchange:sections-updated', () => {
            this.buyboxAddToCart = document.querySelector('.js-product-buybox-buy-buttons')
            this.stockAlertButton = this.querySelector('.js-stock-alert-button')

            this.buttonSticky = this.querySelector('.product-sticky-buybox__button-text')
            this.mainProductOptions = document.querySelectorAll('.product-variant-option-form');

            this.variantSelectMobile = document.querySelector('.product-sticky-buybox__select');

            this.bindEvents();
        })

        this.isMobile = window.matchMedia(`(max-width: 1024px)`).matches;

        this.syncSwatchesAndComboBox();
        this.observeSwatchChanges();
        this.observeSubscriptionInfoChanges();
    }

    bindEvents() {
        if (this.productStickyBuybox) {
            window.addEventListener('scroll', () => {
                this.toggleVisibility()
            }, false);

            window.addEventListener('resize', () => {
                this.toggleVisibility()
            }, false);

            //this.scrollToCreateAlert()

            // A SUPPRIMER
            // Add event listener to product-option-value elements
            const optionValues = this.querySelectorAll('.product-option-value');
            optionValues.forEach(optionValue => {
                optionValue.addEventListener('click', this.updateVariantText);
                optionValue.addEventListener('click', this.clickVariantProductForm);
            });

            this.buttonSticky.addEventListener('click', this.clickAddToCartProductForm);

            //this.variantSelectMobile.addEventListener('change', this.handleSelectChange);

            //click dans le product form
            const swatches = document.querySelectorAll('.block-swatch');
            swatches.forEach(swatch => {
                swatch.addEventListener('click', this.updateSelectedValue);
            });
            const swatchesRecharge = document.querySelectorAll('.product-subscription-widget-container .product-subscription-widget-select-items div');
            swatchesRecharge.forEach(swatch => {
                swatch.addEventListener('click', this.updateSelectedValueRecharge);
            });

            //click dans la sticky bar
            const comboBoxItems = document.querySelectorAll('.variant-option');
            comboBoxItems.forEach(item => {
                item.addEventListener('click', this.handleComboBoxClick);
            });
            const swatchesRechargeBuybox = document.querySelectorAll('.product-sticky-buybox .product-subscription-widget-select-items div');
            swatchesRechargeBuybox.forEach(item => {
                console.log('passe click')
                item.addEventListener('click', this.handleSubscriptionSelectClick);
            });
        }
    }

    observeSwatchChanges() {
        const swatchList = document.querySelector('.block-swatch-list');
        if (swatchList) {
            const swatches = swatchList.querySelectorAll('.block-swatch');
            const observerConfig = {
                attributes: true,
                attributeFilter: ['class']
            };

            const observerCallback = () => {
                this.syncSwatchesAndComboBox();
            };

            const observer = new MutationObserver(observerCallback);

            swatches.forEach(swatch => {
                observer.observe(swatch, observerConfig);
            });
        }
    }

    observeSubscriptionInfoChanges() {
        const subscriptionInfoDiv = document.querySelector('[data-subscription-infos]');
        const subscriptionSelectDiv = this.querySelector('.product-sticky-buybox .product-subscription-widget-custom-select');

        if (subscriptionInfoDiv && subscriptionSelectDiv) {
            const observer = new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                    if (mutation.attributeName === 'class') {
                        const isHidden = subscriptionInfoDiv.classList.contains('hidden');
                        if (!isHidden) {
                            subscriptionSelectDiv.classList.remove('hidden');
                        } else {
                            subscriptionSelectDiv.classList.add('hidden');
                        }
                    }
                });
            });

            observer.observe(subscriptionInfoDiv, { attributes: true });
        }
    }

    syncSwatchesAndComboBox() {
        const swatchList = document.querySelector('.block-swatch-list');
        const comboBoxOptions = document.querySelectorAll('.combo-box__option-list .variant-option');

        console.log('sync')

        if (swatchList && comboBoxOptions.length > 0) {
            const swatches = swatchList.querySelectorAll('.block-swatch');
            swatches.forEach((swatch, index) => {
                const comboBoxOption = comboBoxOptions[index];
                if (swatch.classList.contains('hidden')) {
                    comboBoxOption.classList.add('hidden');
                } else {
                    comboBoxOption.classList.remove('hidden');
                }
            });
        }
    }

    updateSelectedValue(event) {
        const swatch = event.currentTarget;
        const swatchItem = swatch.querySelector('.block-swatch__radio');
        const selectedValueElement = document.querySelector('.select__selected-value');

        if (swatchItem && selectedValueElement) {
            selectedValueElement.textContent = swatchItem.value;

            const allOptionItems = document.querySelectorAll('.combo-box__option-item');
            allOptionItems.forEach(item => item.classList.remove('active'));

            const matchingOptionItem = Array.from(allOptionItems).find(item => item.textContent.trim() === selectedValueElement.textContent.trim());
            if (matchingOptionItem) {
                matchingOptionItem.classList.add('active');
            }
        }
        console.log('passe click selected value')
    }

    updateSelectedValueRecharge() {
        const sameAsSelectedElement = document.querySelector('.product-sticky-buybox .product-subscription-widget-same-as-selected');
        const selectedValueElement = document.querySelector('.product-sticky-buybox .product-subscription-widget-select-selected');

        if (sameAsSelectedElement && selectedValueElement) {
            selectedValueElement.innerHTML = sameAsSelectedElement.innerHTML;
        }
    }

    handleComboBoxClick(event) {
        event.preventDefault();
        event.stopPropagation();

        document.body.style.overflow = 'hidden';

        const clickedValue = event.currentTarget.getAttribute('value_variante');

        console.log(clickedValue)

        const swatches = document.querySelectorAll('.block-swatch');
        swatches.forEach(swatch => {
            const input = swatch.querySelector('.block-swatch__radio');
            if (input && input.value === clickedValue) {
                swatch.querySelector('input').click();
            }
        });

        setTimeout(() => {
            document.body.style.overflow = '';
        }, 100);
    }

    handleSubscriptionSelectClick(event) {
        const swatch = event.currentTarget;

        const index = Array.from(swatch.parentNode.children).indexOf(swatch);

        const correspondingSwatch = document.querySelectorAll('.product-subscription-widget-container .product-subscription-widget-select-items div')[index];

        if (correspondingSwatch) {
            correspondingSwatch.click();
        }

        function createSVG() {
            var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("focusable", "false");
            svg.setAttribute("width", "12");
            svg.setAttribute("height", "8");
            svg.setAttribute("class", "icon icon--chevron");
            svg.setAttribute("viewBox", "0 0 12 8");

            var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
            path.setAttribute("fill", "none");
            path.setAttribute("d", "M1 1l5 5 5-5");
            path.setAttribute("stroke", "currentColor");
            path.setAttribute("stroke-width", "2");

            svg.appendChild(path);
            return svg;
        }

        setTimeout(() => {
            const element = this.querySelector('.product-sticky-buybox .product-subscription-widget-select-selected');
            element.appendChild(createSVG());
        }, 10);
    }

    isInViewport(el) {
        const rect = el.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const navHeight = window.innerWidth < 741 ? 60 : 76;

        return (
            rect.bottom > navHeight &&
            rect.top < viewportHeight
        );
    }



    toggleVisibility() {
        if(!this.isInViewport(this.buyboxAddToCart)) {
            this.productStickyBuybox.classList.add('product-sticky-buybox--visible');
        } else {
            if(this.productStickyBuybox.classList.contains('product-sticky-buybox--visible')) {
                this.productStickyBuybox.classList.remove('product-sticky-buybox--visible');

                var select_sticky = this.querySelector('.product-sticky-buybox__wrapper .select')
                if (select_sticky){
                    var isExpanded = select_sticky.getAttribute('aria-expanded') === 'true';
                    if (isExpanded) {
                        select_sticky.click();
                    }
                }

                var subscription_sticky = this.querySelector('.product-sticky-buybox__wrapper .product-subscription-widget-select-selected')
                if (subscription_sticky){
                    var isExpandedSubs = subscription_sticky.classList.contains('product-subscription-widget-select-arrow-active')
                    if (isExpandedSubs) {
                        subscription_sticky.click();
                    }
                }

            }
        }
    }

    /*scrollToCreateAlert() {
        this.stockAlertButton = this.querySelector('.product-sticky-buybox__button-text')
        const outOfStockElement = this.querySelector('.out-of-stock-sticky-buybox');

        //doit etre false
        if (this.stockAlertButton && outOfStockElement && !outOfStockElement.classList.contains('u-none')) {
            this.stockAlertButton?.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
                document.querySelector('.js-stock-alert-btn').click();
            })
        }

    }*/

    updateVariantText(event) {
        const input = event.target.closest('label').previousElementSibling;
        if (input && input.classList.contains('product-variant-option--unavailable')) {
            document.querySelector('.available-sticky-buybox').classList.add('u-none');
            document.querySelector('.out-of-stock-sticky-buybox').classList.remove('u-none');
        } else {
            document.querySelector('.available-sticky-buybox').classList.remove('u-none');
            document.querySelector('.out-of-stock-sticky-buybox').classList.add('u-none');
        }
    }

    clickVariantProductForm(event) {
        const value = event.target.closest('label').previousElementSibling.value;

        this.mainProductOptions.forEach(option => {
            if (option.value === value) {
                const label = option.nextElementSibling;
                if (label && label.tagName === 'LABEL') {
                    label.click();
                }
            }
        });
    }

    clickAddToCartProductForm() {
        document.querySelector('.product-form__add-button').click()
    }

    handleSelectChange(event) {
        const value = event.target.value;

        const mainProductOptions = document.querySelectorAll('.product-variant-option');
        mainProductOptions.forEach(option => {
            if (option.value === value) {
                const label = option.nextElementSibling;
                if (label && label.tagName === 'LABEL') {
                    label.click();
                }
            }
        });
    }
}

customElements.define('w3-product-sticky-buybox', ProductStickyBuybox);
